import DOMUtils from '@/utils/DOMUtils'
import ServicesUtils from '@/utils/servicesUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import Config from '~/config'
import urljoin from 'url-join'
import EventsUtils from './eventsUtils'

export default class BootsrapperUtils
{
    static get data () { return window.bootstrapperData = window.bootstrapperData || {} }
    static get hasBeenBootstrapped ()  { return this.data.hasBeenBootstrapped || false }
    static set hasBeenBootstrapped (val)  { return this.data.hasBeenBootstrapped = val }
    static get originalEnvCityId ()  { return this.data.originalEnvCityId || null }
    static set originalEnvCityId (val)  { return this.data.originalEnvCityId = val }

    static async reloadApp (version)
    {

        EventsUtils.fireBootstrapping()

        this.originalEnvCityId = EnvironmentUtils.envCityId
        this.hasBeenBootstrapped = true

        const files =
        {
            css: [`${version}/app.css`],
            js:
            [
                `${version}/manifest.js`,
                `${version}/vendor.js`,
                `${version}/app.js`,
                // 'cordova.js'
            ]
        }
        const urls = files
            .css.map(path => urljoin(Config.appRegistryUrl, path))
            .concat(files.js.map(path => urljoin(Config.appRegistryUrl, path)))
        
        for (const url of urls)
        {
            if (!ServicesUtils.isResourceAvailable(url))
            {
                console.log(`${url} is not available`)

                return false
            }
        }

        const scriptElemRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script\s*>/gmi
        const linkElemeRegex = /<link (.)*rel=stylesheet>/gmi
        const html = document.getElementsByTagName('html')[0]
        html.innerHTML =  html.innerHTML.replace(scriptElemRegex, '')
        html.innerHTML =  html.innerHTML.replace(linkElemeRegex, '')
        document.getElementById('app').innerHTML = ''
        console.log('preparing to delete all stylesheets')
        DOMUtils.clearStylesheets()

        for (const file of files.css) await DOMUtils.appendLinkElem(urljoin(Config.appRegistryUrl, file), 'stylesheet')
        for (const file of files.js) await DOMUtils.appendScriptElem(urljoin(Config.appRegistryUrl, file))

        EventsUtils.fireBootstrapped()
        return true
    }
}


// WEBPACK FOOTER //
// ./src/utils/bootstrapperUtils.js